// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"vf","title":"wf","nav":"xf","flexCell":"yf","facetLink":"zf"};